import { useEffect, useState } from "react";
import { getSystemById } from "../services/systemService";

const useFetchSystemById = ({
  setIsLoading,
  currentSystemId,
}: {
  setIsLoading?: (loading: boolean) => void;
  currentSystemId?: string;
}) => {
  const [systemData, setSystemData] = useState<any>(null);

  useEffect(() => {
    const fetchSystem = async () => {
      if (!currentSystemId) return;

      try {
        if (setIsLoading) setIsLoading(true);
        const result = await getSystemById(currentSystemId);
        setSystemData(result);
      } catch (error) {
        console.error("Error fetching system by ID:", error);
        setSystemData(null);
      } finally {
        if (setIsLoading) setIsLoading(false);
      }
    };

    fetchSystem();
  }, [currentSystemId]); // ✅ Removed setIsLoading to prevent infinite loops

  return [systemData];
};

export default useFetchSystemById;
